import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Listings } from 'containers/AppContainer/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { get } from 'lodash';
import ExpertReport from 'containers/common/LegalProceedings/ExpertReport';
export interface ExpertReportFormProps {
  intl: IntlShape;
  listings: Listings;
  policyInfo: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  procedureInstance: any;
  judgementAddDocuments: any;
  expertiseReport: any;
  setProcedureInstance: Function;
  documentId: any;
  setDocumentId: Function;
  expertReportState: any;
  setExpertReportState: Function;
  requestGetDocByDocumentumId: Function;
}

export const ExpertReportForm: React.FC<ExpertReportFormProps> = (
  props,
): JSX.Element => {
  return (
    <>
      <ExpertReport
        listings={props.listings}
        claimId={get(props.procedureInstance, 'claimId')}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        resetUploadedDocument={props.resetUploadDocumentStore}
        expertReportState={props.expertReportState as any}
        setExpertReportState={props.setExpertReportState}
        expertReport={{} as any}
        setIsDecisionDialgOpen={() => {}}
        isDecisionDialgOpen={false}
        isManager={false}
        isAssignedLawyer={false}
        claimNumber={get(props.procedureInstance, 'claimNumber')}
        victimExpertises={[]}
        vehicleExpertises={[]}
        judgementAddDocuments={[]}
        judiciaryProcessId={get(props.procedureInstance, 'judiciaryProcessId')}
        documentId={props.documentId}
        setDocumentId={props.setDocumentId}
        requestCreateExpertiseRaport={() => {}}
        requestValidateExpertReport={() => {}}
        requestGetExpertiseRaport={() => {}}
        victims={[]}
        claim={{} as any}
        policyInfo={props.policyInfo}
        hasJom={false}
        sagisVictimInfo={null}
        sagisOpposingParties={null}
        isBasicManagement
        imagineDocuments={[]}
        expertiseRaportFirstInstance={[]}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
    </>
  );
};

export default injectIntl(ExpertReportForm);
